import React, { createContext, useState, useContext, useRef, useEffect } from 'react';

// Import sound files
import hoverSoundFile from '../assets/sounds/hover.mp3';
import clickSoundFile from '../assets/sounds/click.mp3';
import { vibrate } from '../lib/vibration';

const SoundContext = createContext();

export const SoundProvider = ({ children }) => {
  const [isSoundEnabled, setIsSoundEnabled] = useState(true); // Default to enabled
  
  // Refs to hold audio objects
  const hoverAudioRef = useRef(null);
  const clickAudioRef = useRef(null);

  useEffect(() => {
    hoverAudioRef.current = new Audio(hoverSoundFile);
    clickAudioRef.current = new Audio(clickSoundFile);
    
    // Preload sounds
    hoverAudioRef.current.load();
    clickAudioRef.current.load();
  }, []);

  const toggleSound = () => {
    setIsSoundEnabled(prev => !prev);
  };

  const playHover = () => {
    if (isSoundEnabled && hoverAudioRef.current) {
      hoverAudioRef.current.currentTime = 0; // Reset to start
      hoverAudioRef.current.play().catch(e => console.error("Audio play failed", e));
    }
  };

  const playClick = () => {
    vibrate(15);
    if (isSoundEnabled && clickAudioRef.current) {
        clickAudioRef.current.currentTime = 0;
        clickAudioRef.current.play().catch(e => console.error("Audio play failed", e));
    }
  };

  return (
    <SoundContext.Provider value={{ isSoundEnabled, toggleSound, playHover, playClick, vibrate }}>
      {children}
    </SoundContext.Provider>
  );
};

export const useSound = () => useContext(SoundContext);
